import { actionMap } from 'app/shared/util/action-methodes-list';
import React, { useState } from 'react';
import { ButtonLounge } from '../button/button-louge';
import ModalWithAction from '../modal/modal-with-Action';
import { getModalInformationButton } from 'app/modules/cms/service/store/selectors';
import { useSelector } from 'react-redux';

interface IActionComponent {
  action: string;
  label: any;
  style?: any;
  ActionData?: any;
  param?: any;
  loading?: any;
  getConstraint?: any;
  disabledProp?: any;
}

const ActionComponent = (props: IActionComponent) => {
  const { action, label, style, ActionData, param, loading, getConstraint, disabledProp } = props;
  const [openModal, setOpenModal] = useState(false);
  const modalInformation: any = useSelector(getModalInformationButton);
  const r = { disabledBtn: false, showBtn: true, showPopup: false };

  const findAction = ActionData.find(e => e.actionDataKey === action);
  let constraintParams;
  if (findAction !== undefined && findAction !== null) {
    constraintParams = (Object.entries(findAction?.params || {}) || []).filter(([key, value]) => key.startsWith('STRUCT'));
    const resultArray = constraintParams.map(e => getConstraint(e[0], e[1]));

    resultArray.map(e => {
      r.disabledBtn = Boolean(r.disabledBtn + e?.disabled);
      r.showPopup = Boolean(r.showPopup + e?.showPopup);
      if (!e.show) r.showBtn = false;
    });
  }

  let method = actionMap.get(action);
  if (param && param?.specificAction) method = param?.specificAction;

  const startAction = () => {
    r.showPopup ? setOpenModal(r.showPopup) : method(param);
  };
  console.log("test",r,action)

  return (
    <>
      {findAction && r.showBtn && (
        <ButtonLounge
          title={label}
          style={(r.disabledBtn || disabledProp )? '1Disable mb-2' : style}
          action={() => startAction()}
          loading={loading}
          disabled={r.disabledBtn || disabledProp}
        />
      )}
      {r.showPopup && (
        <ModalWithAction
          icon={modalInformation?.erreur_Icon?.url}
          showModal={openModal}
          setShowModel={setOpenModal}
          textBody={"Suite à des conditions d'éligibilité, vous ne pouvez pas déclarer de sinistre."}
          action={() => {
            setOpenModal(false);
          }}
          btnActionLabel={modalInformation?.CLOSE_button}
        />
      )}
    </>
  );
};

export default ActionComponent;
